var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isContentVisible
    ? _c(
        "div",
        {
          staticClass:
            "proofreading-select-type proofreading-select-type--locked",
          class: {
            "proofreading-select-type--error": _vm.pendingWorkFetchFailed,
          },
          attrs: { role: "status", "aria-live": "polite" },
        },
        [
          _vm.pendingWorkFetchFailed
            ? _c(
                "p",
                { staticClass: "proofreading-select-type__fetch-error" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "proofreadingSelectTypePage.pendingWorkFetchError"
                        )
                      ) +
                      " "
                  ),
                ]
              )
            : _c("LoadingSpinner", {
                attrs: { size: "medium", variant: "inline" },
              }),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "proofreading-select-type",
          attrs: { "aria-busy": _vm.isProcessingCardClick ? "true" : "false" },
        },
        [
          _c(
            "div",
            { staticClass: "proofreading-select-type__speech" },
            [
              _c("ChatMessage", {
                staticClass: "proofreading-select-type__chat-message",
                attrs: {
                  message: _vm.$t("proofreadingSelectTypePage.speechMessage"),
                  "cat-icon-size": "medium",
                },
              }),
            ],
            1
          ),
          _c("h1", { staticClass: "proofreading-select-type__heading" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("proofreadingSelectTypePage.heading")) + " "
            ),
          ]),
          _c("div", { staticClass: "proofreading-select-type__cards" }, [
            _c("div", { staticClass: "type-card-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "type-card type-card--active",
                  attrs: { type: "button" },
                  on: { click: _vm.onClickBasic },
                },
                [
                  _c("IconBook", {
                    staticClass: "type-card__icon",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _c("p", { staticClass: "type-card__title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("proofreadingSelectTypePage.basicTitle"))
                    ),
                  ]),
                  _c("p", { staticClass: "type-card__description" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("proofreadingSelectTypePage.basicDescription")
                      )
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "type-card-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "type-card type-card--active",
                  attrs: { type: "button" },
                  on: { click: _vm.onClickAi },
                },
                [
                  _c("IconRobot", {
                    staticClass: "type-card__icon",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _c("p", { staticClass: "type-card__title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("proofreadingSelectTypePage.aiTitle"))
                    ),
                  ]),
                  _c("p", { staticClass: "type-card__description" }, [
                    _vm._v(
                      _vm._s(_vm.$t("proofreadingSelectTypePage.aiDescription"))
                    ),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }